import { connect } from 'react-redux'
import get from 'lodash/get'

import { fetchServicing } from '../../actions/servicings'
import { loadIssuesForServicing } from '../../actions/issues'

import {
  needsWorkSelector,
  needsReviewSelector,
  permanentSelector,
  resolvedSelector
} from '../../selectors/issue-selectors'

import IssuesList from '../../components/issues/issues-list'

function mapStateToProps (state, ownProps) {
  const pagination = get(state, `pagination.issuesByServicing.${ownProps.params.servicingId}`, {})

  return {
    needsWork: needsWorkSelector(state, "issuesByServicing", ownProps.params.servicingId),
    needsReview: needsReviewSelector(state, "issuesByServicing", ownProps.params.servicingId),
    permanent: permanentSelector(state, "issuesByServicing", ownProps.params.servicingId),
    resolved: resolvedSelector(state, "issuesByServicing", ownProps.params.servicingId),
    hasNextPage: pagination.nextPageUrl
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchServicing(ownProps.params.servicingId))
    .then((action) => {
      const locationId = action.payload.entities.servicings[action.payload.result].location

      dispatch(loadIssuesForServicing(locationId, ownProps.params.servicingId))
    })

  return {
    onLoadNextPage () {
      dispatch(loadIssuesForLocation(ownProps.params.locationId, true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssuesList)



// WEBPACK FOOTER //
// ./src/containers/issues/servicing-issues-list-container.js